import { flattenRoutes } from '../../config/routes';

export const APP_TITLE = 'OBAS订单BOM辅助系统';

type RouteMatch = {
  route?: {
    name?: string;
    path?: string;
  };
};

export function getPageTitle(pageName?: string): string {
  return pageName ? `${pageName} - ${APP_TITLE}` : APP_TITLE;
}

export function resolveRouteName(
  pathname: string,
  matches?: RouteMatch[] | null,
): string {
  if (matches?.length) {
    for (let i = matches.length - 1; i >= 0; i--) {
      const name = matches[i]?.route?.name;
      if (name) return name;
    }
  }

  const exact = flattenRoutes.find((route) => route.path === pathname);
  if (exact?.name) return exact.name;

  const candidates = flattenRoutes
    .filter(
      (route) =>
        route.path &&
        route.name &&
        (pathname === route.path || pathname.startsWith(`${route.path}/`)),
    )
    .sort((a, b) => (b.path?.length || 0) - (a.path?.length || 0));

  return candidates[0]?.name || '';
}

export function getPageTitleForPathname(
  pathname: string,
  matches?: RouteMatch[] | null,
): string {
  return getPageTitle(resolveRouteName(pathname, matches));
}

export function updateDocumentTitle(
  pathname: string,
  matches?: RouteMatch[] | null,
): string {
  const title = getPageTitleForPathname(pathname, matches);
  document.title = title;
  return title;
}
